/* Recent browser activity; numbers are fetched with the existing two-minute lease, never fabricated. */
(function () {
 'use strict';
 var configEl=document.getElementById('diggn-store-presence');
 if(!configEl||window.__diggnStorePresenceLoaded)return;
 window.__diggnStorePresenceLoaded=true;
 var config;try{config=JSON.parse(configEl.textContent);}catch(e){return;}
 if(config.endsAt&&Date.now()>=Date.parse(config.endsAt)){configEl.dataset.state='pilot-complete';return;}
 var qa=new URLSearchParams(location.search).get('codex_presence_qa')==='1';
 if(window.Shopify&&Shopify.designMode||new URLSearchParams(location.search).has('preview_theme_id'))return;
 if(navigator.webdriver&&!qa)return;
 var socket=null,pending=null,generation=0,lastInput=Date.now(),leaseAt=0,retryAt=0,failures=0,stopped=false,sessionValue=null;
 var activityReading=null,activityExpires=0,display=null;
 var arabic=(document.documentElement.lang||'').toLowerCase().indexOf('ar')===0;
 function hideActivity(){if(display)display.hidden=true;activityReading=null;activityExpires=0;}
 function renderActivity(){
  if(!config.productId||!activityReading||!eligible()||Date.now()>=activityExpires||!socket||socket.readyState!==1){if(display)display.hidden=true;return;}
  var product=activityReading.product,store=activityReading.store;
  var count=product>0?product:store,scope=product>0?'product':'store';
  if(!Number.isInteger(count)||count<1||count>200){if(display)display.hidden=true;return;}
  var form=document.querySelector('product-info[id^="MainProduct-"] product-form')||document.querySelector('.product__info-container product-form');
  if(!form)return;
  if(!display||!display.isConnected){
   display=document.createElement('div');display.className='diggn-product-activity';display.hidden=true;
   var dot=document.createElement('span');dot.className='diggn-product-activity__dot';dot.setAttribute('aria-hidden','true');
   var label=document.createElement('span');label.className='diggn-product-activity__label';
   var details=document.createElement('details');details.className='diggn-product-activity__details';
   var summary=document.createElement('summary');summary.className='diggn-product-activity__summary';summary.textContent='ⓘ';summary.setAttribute('aria-label',arabic?'عن هذا العدد':'About this count');
   var explanation=document.createElement('p');explanation.className='diggn-product-activity__explanation';
   explanation.textContent=arabic?'زيارات من متصفحات نشطة خلال آخر ١٥ دقيقة، باستثناء زيارتك. يُحدَّث العدد كل دقيقتين تقريبًا، ولا يدل على عمليات شراء.':'Active browser visits in the last 15 minutes, excluding your own. Refreshed about every two minutes. This does not indicate purchases.';
   details.appendChild(summary);details.appendChild(explanation);display.appendChild(dot);display.appendChild(label);display.appendChild(details);form.insertAdjacentElement('afterend',display);
  }
  var prefix=arabic?(scope==='product'?'زيارات حديثة لهذا المنتج: ':'زيارات حديثة في المتجر: '):(scope==='product'?'Recent visits to this product: ':'Recent visits in the store: ');
  display.querySelector('.diggn-product-activity__label').textContent=prefix+new Intl.NumberFormat(arabic?'ar-SA':'en').format(count);
  display.dataset.scope=scope;display.hidden=false;
 }
 var key='diggn-presence-session-v1',sessionLife=30*60*1000;
 function status(value){configEl.dataset.state=value;}
 function allowed(){try{return window.Shopify&&Shopify.customerPrivacy&&Shopify.customerPrivacy.analyticsProcessingAllowed()===true;}catch(e){return false;}}
 function eligible(){return allowed()&&!document.hidden&&document.hasFocus()&&Date.now()-lastInput<900000;}
 function close(value){
  hideActivity();
  generation++;if(pending){pending.abort();pending=null;}
  if(socket){socket.onclose=null;socket.onerror=null;try{socket.close();}catch(e){}socket=null;}
  leaseAt=0;status(value);
 }
 function session(){
  var saved;try{saved=JSON.parse(localStorage.getItem(key)||'null');}catch(e){}
  if(saved&&/^[0-9a-f-]{36}$/i.test(saved.value)&&Date.now()-saved.createdAt<sessionLife){sessionValue=saved.value;return sessionValue;}
  if(!sessionValue)sessionValue=crypto.randomUUID();
  try{localStorage.setItem(key,JSON.stringify({value:sessionValue,createdAt:Date.now()}));}catch(e){}
  return sessionValue;
 }
 function failure(){
  failures++;retryAt=Date.now()+Math.min(300000,10000*Math.pow(2,Math.min(failures,5)))+Math.random()*5000;
  close('unavailable');
 }
 async function connect(){
  if(pending||socket||stopped||!eligible()||Date.now()<retryAt)return;
  var current=++generation,controller=new AbortController();pending=controller;status('connecting');
  var timeout=setTimeout(function(){controller.abort();},10000);
  try{
   var body={session:session(),qa:qa};
   if(config.productId)body.productId=String(config.productId);
   // JSON in a safelisted text body: Floot's automatic OPTIONS response has no CORS headers.
   var response=await fetch(config.endpoint,{method:'POST',mode:'cors',credentials:'omit',headers:{'Content-Type':'text/plain'},body:JSON.stringify(body),signal:controller.signal});
   if(current!==generation)return;
   if(!response.ok){
    if(response.status===503){stopped=true;close('measurement-paused');return;}
    failure();return;
   }
   var result=await response.json();
   if(current!==generation||!eligible())return;
   if(typeof result.token!=='string'||typeof result.wssEndpoint!=='string'||!Array.isArray(result.channels)||!Number.isFinite(result.expiresAt)){failure();return;}
   var checked=result.activity&&Date.parse(result.activity.checkedAt);
   if(result.activity&&Number.isInteger(result.activity.store)&&result.activity.store>=0&&Number.isInteger(result.activity.product)&&result.activity.product>=0&&Date.now()-checked>=-5000&&Date.now()-checked<30000){activityReading=result.activity;activityExpires=Math.min(result.expiresAt,checked+120000);}
   var ws=new WebSocket(result.wssEndpoint+(result.wssEndpoint.indexOf('?')<0?'?':'&')+'token='+encodeURIComponent(result.token));
   socket=ws;leaseAt=Math.min(result.expiresAt,Date.now()+120000);
   ws.onopen=function(){
    if(current!==generation||!eligible()){close('inactive');return;}
    failures=0;result.channels.forEach(function(channel){ws.send(JSON.stringify({action:'subscribe',channel:channel}));});
    status(qa?'qa-connected':'connected');
    renderActivity();
   };
   ws.onmessage=function(event){
    /* Subject-only grants receive no visitor roster. Surface protocol failures without logging identity. */
    try{var message=JSON.parse(event.data);if(message.error||message.type==='error')failure();}catch(e){}
   };
   ws.onclose=function(){if(socket===ws)failure();};
   ws.onerror=function(){if(socket===ws)failure();};
  }catch(e){if(current===generation)failure();}
  finally{clearTimeout(timeout);if(pending===controller)pending=null;}
 }
 function reconcile(){
  if(stopped)return;
  if(config.endsAt&&Date.now()>=Date.parse(config.endsAt)){stopped=true;close('pilot-complete');return;}
  if(!allowed()){
   close('consent-unavailable');sessionValue=null;
   try{localStorage.removeItem(key);}catch(e){}
   return;
  }
  if(!eligible()){if(socket||pending)close('inactive');else {hideActivity();status('inactive');}return;}
  if(socket&&Date.now()>=leaseAt)close('renewing');
  if(!socket&&!pending)void connect();
  renderActivity();
 }
 function activity(){lastInput=Date.now();reconcile();}
 ['pointerdown','keydown','touchstart','scroll'].forEach(function(name){window.addEventListener(name,activity,{passive:true});});
 window.addEventListener('focus',activity);
 window.addEventListener('blur',function(){close('inactive');});
 document.addEventListener('visibilitychange',function(){if(!document.hidden)lastInput=Date.now();reconcile();});
 document.addEventListener('visitorConsentCollected',reconcile);
 window.addEventListener('storage',function(event){if(event.key===key)reconcile();});
 window.addEventListener('pagehide',function(){stopped=true;close('inactive');});
 window.addEventListener('pageshow',function(){stopped=false;lastInput=Date.now();reconcile();});
 setInterval(reconcile,1000);
 if(window.Shopify&&!Shopify.customerPrivacy&&typeof Shopify.loadFeatures==='function'){
  Shopify.loadFeatures([{name:'consent-tracking-api',version:'0.1'}],function(){reconcile();});
 }
 reconcile();
}());
